import React from 'react';
import FreshChat from 'react-freshchat';
import useAuth from '../../../user/utils/auth/useAuth';
import config from '../../config/index';

export default function FreshchatProvider() {
  const { user } = useAuth();
  if (!process.browser) {
    return null;
  }
  return (
    <FreshChat
      token={config.freshchatToken}
      email={user && user.email}
      externalId={user && user.id}
      onInit={widget => {
        if (user) {
          widget.user.setFirstName(user.fullname);
          widget.user.setProperties({
            host: 'https://wchat.freshchat.com',
            email: user.email,
            email_verified: user.email_verified,
            kyc_level: user.kyc_level,
            phone: user.phone_number
          });
        }
      }}
    />
  );
}
